var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6904 4.35138C23.7446 3.88287 24.9487 3.88287 26.0029 4.35138L40.2725 10.6932C41.7444 11.3475 42.6932 12.807 42.6934 14.4178V33.5799C42.6934 35.1909 41.7446 36.6511 40.2725 37.3055L26.0029 43.6473C24.9487 44.1158 23.7446 44.1158 22.6904 43.6473L8.4209 37.3055C6.94878 36.6511 6 35.1909 6 33.5799V14.4178C6.00016 12.807 6.94893 11.3475 8.4209 10.6932L22.6904 4.35138ZM10.0771 33.5799L22.3086 39.0154V21.3348L10.0771 16.7479V33.5799ZM26.3848 21.3348V39.0154L38.6162 33.5799V16.7479L26.3848 21.3348ZM12.5459 13.3201L24.3457 17.7449L27.4629 16.575L15.917 11.8211L12.5459 13.3201ZM21.0674 9.53302L33.0664 14.4734L36.1455 13.3201L24.3467 8.07599L21.0674 9.53302Z",
    fill: "#05054B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcel);
export default __webpack_public_path__ + "static/media/Parcel.bd11be50dc62036d2ef686d4ab1eb767.svg";
export { ForwardRef as ReactComponent };